import Openseadragon from 'openseadragon';

export type ZoomifyOptions = {
	width: number;
	height: number;
	tilesUrl: string;
	tileSize?: number;
	imageSizes?: { x: number, y: number }[];
	gridSize?: number[];
	minLevel?: number;
	maxLevel?: number;
}

export class FixedZoomify extends (Openseadragon as any).ZoomifyTileSource {
	constructor(options: ZoomifyOptions) {
		super(options);
		options.tileSize = 256;

		const currentImageSize = {
			x: options.width,
			y: options.height
		};
		options.imageSizes = [{
			x: options.width,
			y: options.height
		}];
		options.gridSize = [this._getGridSize(options.width, options.height, options.tileSize)];

		while (currentImageSize.x > options.tileSize || currentImageSize.y > options.tileSize) {
			currentImageSize.x = Math.round(currentImageSize.x / 2);
			currentImageSize.y = Math.round(currentImageSize.y / 2);
			options.imageSizes.push({
				x: currentImageSize.x,
				y: currentImageSize.y
			});
			options.gridSize.push(this._getGridSize(currentImageSize.x, currentImageSize.y, options.tileSize));
		}
		options.imageSizes.reverse();
		options.gridSize.reverse();
		options.minLevel = 0;
		options.maxLevel = options.gridSize.length - 1;

		(Openseadragon as any).TileSource.apply(this, [options]);
	}

    supports(data: { type: string | undefined }, url: string) {
		return (data.type && "fixedzoomifytileservice" == data.type);
	}
}